<div class="global-loader-overlay" *ngIf="loaderService.loading$ | async" data-testid="shared-loader">
  <div class="loader-content">
    <div class="dual-ring-loader"></div>
    <div class="loader-message" *ngIf="loaderService.loadingMessage$ | async as message">
      {{ message }}
    </div>
  </div>
</div>
